import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {connect} from 'pwa-helpers';
import {classMap} from 'lit/directives/class-map.js';
import {msg} from '@lit/localize';
import style from '../../../../scss/image.scss';
import store from '../../store';


@customElement('arc-image')
class Image extends connect(store)(LitElement) {

	static styles = [style];

	static properties = {
		alt: {type: String},
		file: {type: Object},
		noZoom: {type: Boolean}
	};

	constructor() {
		super();
		this.file = null;
		this.alt = '';
		this.noZoom = false;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
	}

	zoom(e) {
		if (this.noZoom) return;

		document.dispatchEvent(new CustomEvent('image-zoom', {
			detail: {
				file: this.file
			},
			bubbles: true,
			composed: true
		}));
	}

	render() {
		if (!this.file) return null;
		const srcset = this.file.thumbs.map((thumb) => thumb.url + ' ' + thumb.w + 'w').join(', ');
		return html`<img class="${classMap({noZoom: this.noZoom})}"
										 @click=${this.zoom}
										 src="${this.file.thumbs[0].url}"
										 srcset="${srcset}"
										 alt="${this.alt}" />`;
	}
}
